import { TranslationObject } from '@ngx-translate/core';
import { AspectTypeEnum } from '@lib.core/entities/indicator-type/indicator-type-enum';

import { ContextMetadata } from '@lib.core/entities/indicator/context-metadata';

export class AspectMetadata {
  aspectNameId: string;
  type: AspectTypeEnum;
  description: TranslationObject;
  contextMetadata: ContextMetadata;

  constructor(
    nameId: string,
    type: AspectTypeEnum,
    description: TranslationObject,
    contextMetadata: ContextMetadata
  ) {
    this.aspectNameId = nameId;
    this.type = type;
    this.description = description;
    this.contextMetadata = contextMetadata;
  }
}